











































import { Component, Vue, Prop } from "vue-property-decorator";

import { Garden } from "@/types";
import { className } from "@/utilities";

import ZoneNavButton from "@/components/ZoneNavButton.vue";

@Component({
  components: { ZoneNavButton },
})
export default class TuinView extends Vue {
  get garden() {
    return this.$store.state.garden as Garden;
  }

  get zones() {
    return this.garden.zones;
  }

  mouseover(event: any) {
    this.hover = className(event.srcElement.innerText);
  }

  mouseout(event: any) {
    this.hover = "";
  }

  hover: string = "";
}
